export interface ForecastMatchFormValues {
  forecastMinWaveHeight: number;
  forecastMaxWindSpeed: number;
  forecastLeadHoursMin: number;
  forecastLeadHoursMax: number;
}

export interface ForecastMatchThresholds {
  minWaveHeight: number;
  maxWindSpeed: number;
  leadHoursMin: number;
  leadHoursMax: number;
}

export const DEFAULT_FORECAST_MATCH_VALUES: ForecastMatchFormValues = {
  forecastMinWaveHeight: 3,
  forecastMaxWindSpeed: 15,
  forecastLeadHoursMin: 1,
  forecastLeadHoursMax: 168,
};

export function serializeForecastMatchThresholds(values: ForecastMatchFormValues): ForecastMatchThresholds {
  return {
    minWaveHeight: values.forecastMinWaveHeight,
    maxWindSpeed: values.forecastMaxWindSpeed,
    // Retain the storage contract; calendar-day filtering is enforced by the server.
    leadHoursMin: DEFAULT_FORECAST_MATCH_VALUES.forecastLeadHoursMin,
    leadHoursMax: DEFAULT_FORECAST_MATCH_VALUES.forecastLeadHoursMax,
  };
}

export function hydrateForecastMatchThresholds(
  thresholds?: Partial<ForecastMatchThresholds> | null,
): ForecastMatchFormValues {
  return {
    forecastMinWaveHeight: thresholds?.minWaveHeight ?? DEFAULT_FORECAST_MATCH_VALUES.forecastMinWaveHeight,
    forecastMaxWindSpeed: thresholds?.maxWindSpeed ?? DEFAULT_FORECAST_MATCH_VALUES.forecastMaxWindSpeed,
    forecastLeadHoursMin: DEFAULT_FORECAST_MATCH_VALUES.forecastLeadHoursMin,
    forecastLeadHoursMax: DEFAULT_FORECAST_MATCH_VALUES.forecastLeadHoursMax,
  };
}
